import { accountPath, buildingPath, inspectionPath, deficienciesPath, workOrderPath } from 'routes';

export default ({ screen, screenId }) => {
  switch (screen) {
    case 'account':
      return accountPath({ id: screenId, anchor: 'deficiencies', _options: true });
    case 'building':
      return buildingPath({ id: screenId, anchor: 'deficiencies', _options: true });
    case 'inspection':
      return inspectionPath(screenId);
    case 'workOrder':
      return workOrderPath(screenId);
    default:
      return deficienciesPath();
  }
};
